import { LeftCircleOutlined, LoadingOutlined, MinusCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Segmented } from 'antd';
import { Collapse, Divider, Progress, Row, Slider, Spin, } from 'antd';
import * as React from 'react';
import { L } from '../../../lib/abpUtility';
import { PagedResultDto } from '../../../services/dto/pagedResultDto';

export interface IWorkflowViewProps {
    primaryColor: string;
    secondaryColor: string;
    entityStates: PagedResultDto<any>;
    stepMove(input: any): void;
    isMobile: boolean;
    loading: boolean;
    titleText: string;
    subtitleText: string;
    currentState: any;
    disableSliderEdit: boolean;
    disableActionEdit: boolean;
}

export interface IWorkflowViewState {
    visible: boolean;
    changeByButtons: boolean;
    selectedStage: number;
}

class WorkflowView extends React.Component<IWorkflowViewProps, IWorkflowViewState> {
    state = {
        visible: false,
        selectedStage: 1,
        changeByButtons: false
    };

    async componentDidMount() {
        this.setState({ selectedStage: 2 });
    }

    handleStageChange = (value: any, currentState: any) => {


        if (value === -1) {
            this.setState({ selectedStage: currentState });
            this.props.stepMove(currentState);
        }
        else {

            if (value === 0) {
                this.setState({ selectedStage: this.props.currentState - 1 });
                this.props.stepMove(this.props.currentState - 1);
            }
            else {
                this.setState({ selectedStage: this.props.currentState + 1 });
                this.props.stepMove(this.props.currentState + 1);
            }

        }
    }

    handleSliderChange = (value: any, totalStages: any, currentFormStage: any) => {

        var selectedStage = this.props.currentState;

        if (value !== 0) {
            var roundedStage = Math.round(parseInt(value))
            var numberStage = Math.round(100 / roundedStage) - 1;
            selectedStage = totalStages - numberStage;
            this.setState({ selectedStage: selectedStage });
            this.props.stepMove(selectedStage);
        }
        else {
            this.setState({ selectedStage: selectedStage });
            this.props.stepMove(selectedStage);
        }

        if (currentFormStage === (selectedStage - 1)) {
            this.setState({ changeByButtons: false });
        }
        else {
            this.setState({ changeByButtons: true });
        }


    }

    render() {

        const { Panel } = Collapse;

        //-------------------------------------------------------
        // Start Local Dynamic Values for Slider
        //--------------------------------------------------------

        const typeStates = this.props.entityStates === undefined ? [] : this.props.entityStates.items;
        const marks: any = {};
        const markKeys: any[] = [];
        const markNames: any[] = [];
        const stateSplit = 100 / (typeStates.length - 1);
        var itemCounter = 0;
        var itemCapCounter = 0;
        const currentStateDecimal = this.props.currentState * stateSplit;

        typeStates.map((x: any) => {

            markNames.push(x.name)
            {
                itemCapCounter === typeStates.length
                    ? markKeys.push(100)
                    : itemCapCounter === 0
                        ? markKeys.push(0)
                        : markKeys.push(itemCounter)
            }

            itemCapCounter = itemCapCounter + 1;
            { itemCapCounter === 1 ? itemCounter = stateSplit : itemCounter = itemCounter + stateSplit }

        })

        markNames.forEach((value: any, i: any) => marks[markKeys[i]] = value);

        //-------------------------------------------------------
        // Start Local Dynamic Values for Actions
        //--------------------------------------------------------

        return (
            <div>
 

                <Row>
                    <div style={{ width: '50%' }}>

                        <Divider className="font-face-gm" type="horizontal" orientation='left' style={{ fontSize: '3em', marginBottom: '5px', }} >

                            {this.props.loading === true ? <div>
                                <div style={{ margin: 'auto', width: '100%', textAlign: 'center' }}>


                                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: this.props.primaryColor }} spin />} />


                                </div>  <div className="font-face-gm" style={{
                                    fontSize: '0.5em',
                                    opacity: '0.75', margin: 'auto', width: '100%',
                                    textAlign: 'center'
                                }}>

                                   


                                </div> </div> :



                                <div style={{ marginTop: '-15px', marginLeft: '-20px', }}>

                                    <div className="font-face-gm" style={{
                                        fontSize: '0.4em',
                                        opacity: '1', margin: 'auto', width: '100%',
                                        textAlign: 'left',

                                    }}>
                                        {this.props.titleText}
                                    </div>

                                    <Divider style={{ marginTop: '0px', marginBottom: '12px' }} />

                                    <div className="font-face-gm" style={{
                                        fontSize: this.props.subtitleText.length > 6 ? '0.65em' : '0.9em',
                                        opacity: '1', margin: 'auto', width: '100%',
                                        textAlign: 'left', marginTop: '-18px'
                                    }}>

                                        {this.props.subtitleText}


                                    </div>


                                </div>


                            }

                        </Divider>
                    </div>
 

                    {this.props.isMobile === true ||  this.props.disableActionEdit  !== false ? null :
 
                        <div style={{ width: '50%', float: 'right', textAlign: 'right' }}>
                            <Row style={{ marginBottom: '5px' }}>
                                <Progress
                                    strokeColor={{
                                        from: this.props.primaryColor,
                                        to: this.props.secondaryColor,
                                    }}
                                    showInfo={false}
                                    percent={100}
                                    status="normal"
                                    size={'small'}
                                />
                            </Row>
                            <Segmented
                                disabled={this.state.changeByButtons}
                                defaultValue={-1}
                                onChange={(e) => this.handleStageChange(e, this.props.currentState)}
                                options={this.props.loading === true ? [] :
                                    typeStates[this.props.currentState].noActions === false ?
                                        (this.props.currentState === 0 || typeStates[this.props.currentState].nextActionOnly === true ?
                                            [
                                                {
                                                    label: (
                                                        <div style={{ padding: 4, marginLeft: 8, marginRight: 8 }}>
                                                            <MinusCircleOutlined style={{ fontSize: 15 }} />
                                                            <div className="font-face-gm">{typeStates[this.props.currentState].name}</div>
                                                        </div>
                                                    ),
                                                    disabled: false,
                                                    value: -1,
                                                },
                                                {
                                                    label: (
                                                        <div style={{ padding: 4 }}>
                                                            <RightCircleOutlined style={{ fontSize: 20 }} />
                                                            <div className="font-face-gm">{typeStates[this.props.currentState].forwardText}</div>
                                                        </div>
                                                    ),
                                                    disabled: false,
                                                    value: 1,
                                                },
                                            ]
                                            : (this.props.currentState === typeStates.length - 1 || typeStates[this.props.currentState].lastActionOnly === true
                                                ?
                                                [
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4 }}>
                                                                <LeftCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].revertText}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: 0,
                                                    },
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4, marginLeft: 8, marginRight: 8 }}>
                                                                <MinusCircleOutlined style={{ fontSize: 20 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].name}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: -1,
                                                    },
                                                ]
                                                :
                                                [
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4 }}>
                                                                <LeftCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].revertText}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: 0,
                                                    },
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4, marginLeft: 8, marginRight: 8 }}>
                                                                <MinusCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].name}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: -1,
                                                    },
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4 }}>
                                                                <RightCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].forwardText}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: 1,
                                                    },
                                                ]))
                                        : []}
                                size={'small'} onResize={undefined} onResizeCapture={undefined} />
                        </div>  




                    }


                </Row> 
                {this.props.isMobile === false ||  this.props.disableActionEdit !== false ? null :

                    <Row style={{ width: '100%', marginBottom: '25px' }}>
                        <div style={{ margin: 'auto' }}>
                            <Row style={{ marginBottom: '5px' }}>
                                <Progress
                                    strokeColor={{
                                        from: this.props.primaryColor,
                                        to: this.props.secondaryColor,
                                    }}
                                    showInfo={false}
                                    percent={100}
                                    status="normal"
                                    size={'small'}
                                />
                            </Row>
                            <Segmented
                                disabled={this.state.changeByButtons}
                                defaultValue={-1}
                                onChange={(e) => this.handleStageChange(e, this.props.currentState)}
                                options={this.props.loading === true ? [] :
                                    typeStates[this.props.currentState].noActions === false ?
                                        (this.props.currentState === 0 || typeStates[this.props.currentState].nextActionOnly === true ?
                                            [
                                                {
                                                    label: (
                                                        <div style={{ padding: 4, marginLeft: 8, marginRight: 8 }}>
                                                            <MinusCircleOutlined style={{ fontSize: 15 }} />
                                                            <div className="font-face-gm">{typeStates[this.props.currentState].name}</div>
                                                        </div>
                                                    ),
                                                    disabled: false,
                                                    value: -1,
                                                },
                                                {
                                                    label: (
                                                        <div style={{ padding: 4 }}>
                                                            <RightCircleOutlined style={{ fontSize: 20 }} />
                                                            <div className="font-face-gm">{typeStates[this.props.currentState].forwardText}</div>
                                                        </div>
                                                    ),
                                                    disabled: false,
                                                    value: 1,
                                                },
                                            ]
                                            : (this.props.currentState === typeStates.length - 1 || typeStates[this.props.currentState].lastActionOnly === true
                                                ?
                                                [
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4 }}>
                                                                <LeftCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].revertText}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: 0,
                                                    },
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4, marginLeft: 8, marginRight: 8 }}>
                                                                <MinusCircleOutlined style={{ fontSize: 20 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].name}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: -1,
                                                    },
                                                ]
                                                :
                                                [
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4 }}>
                                                                <LeftCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].revertText}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: 0,
                                                    },
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4, marginLeft: 8, marginRight: 8 }}>
                                                                <MinusCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].name}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: -1,
                                                    },
                                                    {
                                                        label: (
                                                            <div style={{ padding: 4 }}>
                                                                <RightCircleOutlined style={{ fontSize: 15 }} />
                                                                <div className="font-face-gm">{typeStates[this.props.currentState].forwardText}</div>
                                                            </div>
                                                        ),
                                                        disabled: false,
                                                        value: 1,
                                                    },
                                                ]))
                                        : []}
                                size={'small'} onResize={undefined} onResizeCapture={undefined} />
                        </div>
                    </Row>
                }
 


                <div style={{ margin: 'auto', marginTop: '-15px', marginBottom: '-15px' }}>

                    <Collapse accordion={true}
                        key={'Name'}
                        bordered={true}

                        defaultActiveKey={this.props.isMobile === true ? '' : ''}
                        style={{
                            paddingTop: '0px',
                            paddingBottom: '0px',
                            backgroundColor: 'transparent',
                            marginTop: '0px',
                            border: 'none',
                            boxShadow: 'none'
                        }}>

                        <Panel className="font-face-gm"
                            style={{
                                paddingTop: '0px',
                                paddingBottom: '0px', fontSize: '10', border: 'none',
                            }}
                            header={<div style={{ marginLeft: '20px' }}>{L('Lifecycle')}</div>}
                            key={'processOverview'}>

                            <Slider className="font-face-gm"
                                style={{ width: '90%', marginLeft: '5%' }}
                                onChange={(e: any) => this.handleSliderChange(e, this.props.entityStates.totalCount, this.props.currentState)}
                                step={null}
                                tooltipVisible={false}
                                marks={marks}
                                defaultValue={currentStateDecimal}
                                disabled={this.props.disableSliderEdit} />

                        </Panel>

                    </Collapse>


                </div>
                <div style={{ margin: 'auto', width: '100%' }}>
                    <Row style={{ marginBottom: '5px' }}>
                        <Progress
                            strokeColor={{
                                from: this.props.secondaryColor,
                                to: this.props.primaryColor,
                            }}
                            showInfo={false}
                            percent={100}
                            status="normal"
                            size={'small'}
                        />
                    </Row>
                </div>



            </div>);
    }

}

export default WorkflowView;